module.exports = new __parcel__URL__("faq_expanded_ko.af68a5da.webp").toString();